import React, { useState, useEffect } from "react";

import userAvatar from "../../assets/img/ico/questionmark.svg"; 
import StarRating from "./starRating";

const InternProfileView = () => {
    const [profileData, setProfileData] = useState(null); 

    //faux fetch pour recup les données en attendant l'API
    const fetchProfileData = async () => {
        await new Promise(resolve => setTimeout(resolve, 100)); //delai 100ms

        setProfileData({
            name: "Lucas Prochon",
            title: "Developer Web Full Stack",
            availability: "Disponible immédiatement",
            location: "Nice (06)",
            rating: 4,
            cvUrl: "#", 
            imageUrl: userAvatar, 
            skills: ["Gestion de projet", "Développement Frontend", "React.js", "Intelligence Artificielle", "Node.js", "UX Design"],
            missionHistory: [
                { id: 1, title: "Chef de projet", details: "Paris - CDI - Assistanat...", date: "Janv.2024" },
                { id: 2, title: "Chef de projet", details: "Paris - CDI - Assistanat...", date: "Janv.2024" },
                { id: 3, title: "Chef de projet", details: "Paris - CDI - Assistanat...", date: "Janv.2024" },
            ]
        });
    };

    useEffect(() => {
        fetchProfileData();
    }, []); 

    if (!profileData) {
        return <section className="ipf-layout"><p>Chargement du profil...</p></section>; 
    }

    return (
        <section className="ipf-layout">
            <div className="ipf-main-content">
                <div className="ipf-profile-header">
                    <img src={profileData.imageUrl} alt={profileData.name} className="ipf-profile-picture" />
                    <div>
                        <div className="ipf-name-rating-wrapper">
                            <h1>{profileData.name}</h1>
                            <StarRating rating={profileData.rating} /> 
                        </div>
                        <p>{profileData.title}</p>
                    </div>
                </div>
                <span className="ipf-availability-tag">{profileData.availability}</span>

                {/* Profile Infos */}
                <div className="ipf-profile-info">
                    <h2>Informations du profil</h2>
                    <p className="ipf-info-title">{profileData.title}</p>
                    <p className="ipf-info-location">{profileData.location}</p>
                    <a href={profileData.cvUrl} download className="ipf-download-cv">
                        <span className="ipf-download-icon"></span>
                        Télécharger le CV
                    </a>
                </div>

                {/* Skills */}
                <div className="ipf-profile-skills">
                    <h2>Compétences</h2>
                    <ul className="ipf-skills-list">
                        {profileData.skills.map((skill, index) => (
                            <li key={`skill-${index}`}>{skill}</li>
                        ))}
                    </ul>
                </div>

                {/* Mission Historique */}
                <div className="ipf-mission-history">
                    <h2>Historique des missions</h2>
                    {profileData.missionHistory.map((mission) => (
                        <div key={mission.id} className="ipf-mission-item">
                            <div>
                                <h3>{mission.title}</h3>
                                <p>{mission.details}</p>
                            </div>
                            <span>{mission.date}</span>
                        </div>
                    ))}
                </div>

                <div className="ipf-action-buttons">
                    <button className="btn fill green ipf-call-button">
                        <span className="ipf-call-icon"></span>
                        Appeler
                    </button>
                    <button className="ipf-message-button">
                        <span className="ipf-message-icon"></span>
                        Message
                    </button>
                </div>

            </div>
            <div className="ipf-sidebar">
                <button className="btn fill green ipf-send-offer-button">Envoyer une offre</button>
            </div>
        </section>
    );
};

export default InternProfileView;